import { Anchor, Text } from '@mantine/core';

import { SubscriptionBillingCycle } from 'models';

import { SubscriptionBillingCycleInput } from './SubscriptionBillingCycleInput';

export const SubscriptionBillingCycleControl = ({
    currentBillingCycle,
    toBillingCycle,
    onChange,
}: {
    currentBillingCycle?: SubscriptionBillingCycle | null;
    toBillingCycle: SubscriptionBillingCycle;
    onChange: (billingCycle: SubscriptionBillingCycle) => void;
}) => {
    if (currentBillingCycle) {
        const currentCycleTypeString =
            currentBillingCycle === SubscriptionBillingCycle.MONTHLY ? 'a monthly' : 'an annual';
        const otherCycleTypeString =
            currentBillingCycle === SubscriptionBillingCycle.MONTHLY ? 'an annual' : 'a monthly';

        return (
            <Text>
                You are presently on{' '}
                <Text span inherit fw={600}>
                    {currentCycleTypeString}
                </Text>{' '}
                billing cycle.{' '}
                <Anchor href="mailto:sales@directenergypartners.com" inherit fw={500}>
                    Contact us
                </Anchor>{' '}
                to switch to {otherCycleTypeString} billing cycle.
            </Text>
        );
    }

    return (
        <SubscriptionBillingCycleInput
            value={toBillingCycle}
            onChange={(value) => {
                onChange(value as SubscriptionBillingCycle);
            }}
        />
    );
};
